import { render, staticRenderFns } from "./LogRightArrowSvg.vue?vue&type=template&id=a4d90b30"
import script from "./LogRightArrowSvg.vue?vue&type=script&lang=js"
export * from "./LogRightArrowSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports